import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'
import Admin from '@/components/Admin'
import RegistryAdmin from '@/components/RegistryAdmin'
import PhdRegistry from '@/components/PhdRegistry'
import Prechecker from '@/components/Prechecker'
import Welcome from '@/components/Welcome'
import Profile from '@/components/Profile'
import President from '@/components/President'
import SpecialProponent from '@/components/SpecialProponent'
import VicePresidentA from '@/components/VicePresidentA'
import AcademicConsultant from '@/components/AcademicConsultant'
import ExecutiveBoardMember from '@/components/ExecutiveBoardMember'
import ReappraisalBoardMember from '@/components/ReappraisalBoardMember'
import PrintDecision from '@/components/PrintDecision'
import Viewer from '@/components/Viewer'
import Auditor from '@/components/Auditor'
import AcademicDirector from '@/components/AcademicDirector'

Vue.use(Router)

export default new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/logout',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin
    },
    {
      path: '/RegistryAdmin',
      name: 'Registryadmin',
      component: RegistryAdmin
    },
    {
      path: '/PhdRegistry',
      name: 'PhdRegistry',
      component: PhdRegistry
    },
    {
      path: '/prechecker',
      name: 'prechecker',
      component: Prechecker
    },
    {
      path: '/president',
      name: 'president',
      component: President
    },
    {
      path: '/specialproponent',
      name: 'specialproponent',
      component: SpecialProponent
    },
    {
      path: '/vicepresidentA',
      name: 'vicepresidentA',
      component: VicePresidentA
    },
    {
      path: '/vicepresidentB',
      name: 'vicepresidentA',
      component: VicePresidentA
    },
    {
      path: '/ExecutiveBoardMember',
      name: 'executiveboardmember',
      component: ExecutiveBoardMember
    },
    {
      path: '/SpecialReappraisalBoardMember',
      name: 'reappraisalboardmember',
      component: ReappraisalBoardMember
    },
    // {
    //   path: '/vicepresident',
    //   name: 'vicepresident',
    //   component: VicePresident
    // },
    {
      path: '/academicconsultant',
      name: 'academicconsultant',
      component: AcademicConsultant
    },
    {
      path: '/printdecision',
      name: 'printdecision',
      component: PrintDecision
    },
    {
      path: '/ProcessViewer',
      name: 'ProcessViewer',
      component: Viewer
    },
    {
      path: '/auditor',
      name: 'auditor',
      component: Auditor
    },
    {
      path: '/academicDirector',
      name: 'academicdirector',
      component: AcademicDirector
    }
    // {
    //   path: '*',
    //   redirect: {
    //     name: 'login'
    //   }
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js